import { Container, styled } from "@mui/material";

export const StyledStaticsContainer = {
  CircularLoadingContainer: styled("div")({
    justifyContent: "center",
    marginTop: "230px",
    textAlign: "center",
  }),

  Container: styled("div")({
    backgroundColor: "#f5f6fa",
  }),
};
export const StyledStaticsDashboard = {
  Title: styled("div")({
    display: "flex",
    height: "40px",
    margin: "13px",
    padding: "10px 10px 10px 20px",
    color: "#808080d1",
    backgroundColor: "#80808029",
    borderRadius: "1px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    fontSize: "17px",
  }),

  Grid: styled("div")({
    display: "grid",
    gridTemplateColumns: `repeat(auto-fill, minmax(500px, 1fr))`,
    gridGap: "10px",
  }),

  DashboardContainer: styled(Container)({
    backgroundColor: "#f5f6fa",
  }),
};
